import { PenTool, Type, Calendar, User, Building, FileSignature, Hash } from "lucide-react";
import { FIELD_TYPES } from "./fieldTypes";
import { colors, fonts } from "../../styles/theme";

const ICONS = {
  signature: FileSignature,
  initials: PenTool,
  date: Calendar,
  autofill_name: User,
  autofill_company: Building,
  text: Type,
};

export default function FieldToolbar({ signers, activeSigner, onActiveSigner }) {
  const handleDragStart = (e, fieldType) => {
    e.dataTransfer.setData("application/field-type", fieldType.type);
    e.dataTransfer.effectAllowed = "copy";
  };

  return (
    <div style={{
      width: 220, flexShrink: 0, background: colors.bgCard,
      borderRight: `1px solid ${colors.border}`, display: "flex",
      flexDirection: "column", overflow: "auto",
    }}>
      {/* Signers section */}
      <div style={{ padding: "16px 14px 12px", borderBottom: `1px solid ${colors.border}` }}>
        <div style={{
          fontSize: 10, fontWeight: 700, textTransform: "uppercase",
          letterSpacing: "0.06em", color: colors.textSecondary, marginBottom: 10,
        }}>
          Assign to
        </div>
        {signers.map((s, i) => (
          <button
            key={i}
            onClick={() => onActiveSigner(i)}
            style={{
              display: "flex", alignItems: "center", gap: 8,
              width: "100%", padding: "8px 10px", marginBottom: 4,
              borderRadius: 6, border: "none", cursor: "pointer",
              background: activeSigner === i ? `${s.color}20` : "transparent",
              outline: activeSigner === i ? `2px solid ${s.color}` : "none",
            }}
          >
            <div style={{
              width: 10, height: 10, borderRadius: "50%",
              background: s.color, flexShrink: 0,
            }} />
            <div style={{ textAlign: "left", overflow: "hidden" }}>
              <div style={{
                fontSize: 12, fontWeight: 600, color: colors.text,
                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
              }}>
                {s.label}
              </div>
              <div style={{
                fontSize: 10, color: colors.textSecondary,
                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
              }}>
                {s.email}
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* Field types section */}
      <div style={{ padding: "14px 14px" }}>
        <div style={{
          fontSize: 10, fontWeight: 700, textTransform: "uppercase",
          letterSpacing: "0.06em", color: colors.textSecondary, marginBottom: 10,
        }}>
          Drag fields onto PDF
        </div>
        {FIELD_TYPES.map((ft) => {
          const Icon = ICONS[ft.type] || Hash;
          return (
            <div
              key={ft.type}
              draggable
              onDragStart={(e) => handleDragStart(e, ft)}
              style={{
                display: "flex", alignItems: "center", gap: 10,
                padding: "9px 10px", marginBottom: 4, borderRadius: 6,
                border: `1px solid ${colors.border}`, cursor: "grab",
                background: colors.bg, transition: "border-color 0.15s",
              }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = ft.color}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = colors.border}
            >
              <Icon size={14} color={ft.color} />
              <span style={{ fontSize: 12, fontWeight: 500, color: colors.text, fontFamily: fonts.body }}>
                {ft.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
